import './local.css';

function ClickClick(){
    return (
        <div className='App'>
            <div className="container">
                <div className='header'>
                    <h1>ClickClick</h1>
                </div>
                <div className="body">
                    <p>ClickClick é uma plataforma mobile focada em soluções de mobilidade urbana em Moçambique. Desenvolvida para facilitar o transporte diário dos cidadãos, a ClickClick conecta passageiros a condutores de forma rápida, segura e conveniente.</p>
                    
                    <p><strong>A plataforma ClickClick incluí dois serviços principais:</strong></p>

                    <div className='header'>
                        <h1>ClickTuk</h1>
                    </div>
                    <p>Serviço especializado em transporte de motociclos (moto-táxis), oferecendo:</p>
                    <ul>
                        <li><strong>Solicitação Rápida:</strong> Peça uma moto-táxi com poucos cliques no seu smartphone, ideal para deslocamentos rápidos no trânsito urbano.</li>
                        <li><strong>Rastreamento em Tempo Real:</strong> Acompanhe a localização do condutor e tempo estimado de chegada em tempo real.</li>
                        <li><strong>Preços Transparentes:</strong> Calcule o valor da corrida antes de confirmar, sem surpresas no final.</li>
                        <li><strong>Perfil dos Condutores:</strong> Visualize informações, avaliações e histórico dos condutores para maior segurança.</li>
                        <li><strong>Pagamento Digital:</strong> Opções de pagamento via aplicativo ou dinheiro, conforme preferência.</li>
                    </ul>

                    <div className='header'>
                        <h1>ClickTáxi</h1>
                    </div>
                    <p>Serviço de táxis convencionais para transporte mais confortável e seguro:</p>
                    <ul>
                        <li><strong>Conforto e Espaço:</strong> Transporte ideal para famílias, grupos ou quando se necessita transportar bagagens.</li>
                        <li><strong>Condutores Certificados:</strong> Todos os motoristas passam por um processo de verificação rigorosa para garantir segurança.</li>
                        <li><strong>Veículos Inspecionados:</strong> Frota regularmente vistoriada para garantir condições adequadas de transporte.</li>
                        <li><strong>Avaliação de Serviço:</strong> Sistema de avaliação mútua entre passageiros e condutores para manter a qualidade.</li>
                        <li><strong>Histórico de Viagens:</strong> Acesso ao histórico completo de todas as suas viagens para controle e segurança.</li>
                    </ul>

                    <p><strong>Vantagens da Plataforma ClickClick:</strong></p>
                    <ul>
                        <li>Opções de transporte flexíveis conforme sua necessidade</li>
                        <li>Redução do tempo de espera por transporte</li>
                        <li>Maior segurança com rastreamento e perfis verificados</li>
                        <li>Preços competitivos e transparentes</li>
                        <li>Contribui para formalização do setor de transporte urbano</li>
                        <li>Oportunidade de renda para condutores registados</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ClickClick


